@if (isNavigating()) {
  <div class="nav-progress" role="progressbar" [attr.aria-label]="'common.loading' | transloco"></div>
}

@if (isDevSession()) {
  <p class="support-session-banner" role="status" data-cy="support-session-banner">
    {{ 'app.supportSession.banner' | transloco }}
  </p>
}

<router-outlet></router-outlet>

<!-- Forced reset on a Kundenportal deploy: shown on every page, the login page included. Deferred so the
     dialog + button modules are fetched only once an update is actually pending (initial-bundle budget). -->
@defer (when hasPendingUpdate()) {
  <app-kundenportal-update-dialog />
}
